import { environment } from "src/environments/environment";
import { errorHandler } from "src/app/util/errorHandler";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { authData } from "src/app/util/auth";
import { terms } from "src/app/util/constants";

@Component({
  selector: "app-payment-tranzgate",
  templateUrl: "./payment-tranzgate.component.html",
})
export class PaymentTranzgateComponent implements OnInit {
  constructor(private httpClient: HttpClient, private router: Router) {}
  session = "";
  term = "";
  semester = "";
  sessions: any = [];
  terms: any[] = terms;
  notification: any = {};
  confirmationText = "Are you sure you want to proceed with payments that does not belong to the current session/term?";
  showConfirmDialog = false;

  loading = false;
  skeletonLoader = true;
  _checks = authData("_checks");

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + authData().Token,
    }),
  };

  ngOnInit(): void {
    const baseUrl = `${environment.BASE_URL}/payments/tranzgateSessions`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => {
        if (res.Success) {
          this.sessions = res.Data;
        } else {
          this.notification = errorHandler(res);
        }
      },
      error: (err) => {
        this.notification = errorHandler(err);
      },
      complete: () => {
        this.skeletonLoader = false;
      },
    });
  }

  async confirmResponse(shouldConfirm: boolean) {
    this.showConfirmDialog = false;
    if (shouldConfirm) {
      this.loading = true;
      this.skeletonLoader = true;
      this.proceedToPaymentPage();
    }
    this.loading = false;
    this.skeletonLoader = false;
  }

  tranzgateClientList() {
    if (!this.session) return;
    console.log(this.session, this.term, !this.term);
    this.loading = true;
    this.skeletonLoader = true;
    if (
      this.session != this._checks.CurrentSession || 
      (this.session == this._checks.CurrentSession && this.term != this._checks.CurrentTerm && this.term !== '0')) {
        this.showConfirmDialog = true;
        return;
    }
    else {
      this.proceedToPaymentPage();
    }
  }

  proceedToPaymentPage() {
    const encodedSession = encodeURIComponent(this.session);
    this.router.navigateByUrl(`/payments/tranzgate/${encodedSession}/${this.term}`);
  }
}
